/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ReportAlertDto = {
    /**
     * Title of the alert
     */
    title: string;
    /**
     * Alert message
     */
    message: string;
    /**
     * Detailed description of the alert
     */
    description?: string;
    /**
     * ID of the character associated with the alert
     */
    characterId: string;
    /**
     * Severity level of the alert
     */
    severity?: ReportAlertDto.severity;
    /**
     * Category of the alert
     */
    category?: ReportAlertDto.category;
    /**
     * Additional metadata for the alert
     */
    metadata?: Record<string, any>;
};
export namespace ReportAlertDto {
    /**
     * Severity level of the alert
     */
    export enum severity {
        LOW = 'low',
        MEDIUM = 'medium',
        HIGH = 'high',
        CRITICAL = 'critical',
    }
    /**
     * Category of the alert
     */
    export enum category {
        CHARACTER = 'character',
        ITEM = 'item',
        SYSTEM = 'system',
        MARKET = 'market',
    }
}

